export default {
  translation: {
    'xCloud': 'xCloud',
    'Configuration obtained successfully, initiating offer...': 'Configuration obtained successfully, initiating offer...',
    'Remote offer retrieved successfully...': 'Remote offer retrieved successfully...',
    'Ready to send ICE...': 'Ready to send ICE...',
    'Exchange ICE successfully...': 'Exchange ICE successfully...',
    'Configuring ICE, waiting for response...': 'Configuring ICE, waiting for response...',
    'Connected': 'Connected',
    'Connecting...': 'Connecting...',
    'Disconnecting...': 'Disconnecting...',
    'Toggle Performance': 'Toggle Performance',
    'Toggle Virtual Gamepad': 'Toggle Virtual Gamepad',
    'Disconnect': 'Disconnect',
    'Key Maping': 'Key Maping',
    'Please press the button on the controller, which will be mapped to:': 'Please press the button on the controller, which will be mapped to:',
    'After successful mapping, this pop-up will automatically close': 'After successful mapping, this pop-up will automatically close',
    'Cancel': 'Cancel',
    'Save': 'Save',
    'Saving...': 'Saving...',
    'Saved': 'Saved',
    'Reset': 'Reset',
    'Please press the button on the gamepad; this button will be mapped to:': 'Please press the button on the gamepad; this button will be mapped to:',
    'After successful mapping, this popup will automatically close.': 'After successful mapping, this popup will automatically close.',
    'Warning': 'Warning',
    'The terminal seems to have been without a screen for a long time. Please try reconnecting.': 'The terminal seems to have been without a screen for a long time. Please try reconnecting.',
    'Keep waiting': 'Keep waiting',
    'Exit': 'Exit'
  }
}